import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import {
  Autocomplete,
  CircularProgress,
  TextField,
  IconButton,
} from '@mui/material';
import service from '../service';
import * as MATERIEL_ICONS from '@mui/icons-material/';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';

const boxStyle = {
  outline: 'none',
  position: 'absolute',
  top: '50%',
  left: '50%',
  borderRadius: 30,
  transform: 'translate(-50%, -50%)',
  width: 300,
  minHeight: 300,
  backgroundColor: 'white',
  boxShadow: 24,
  padding: 10,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

function EditMatchingModal(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const hash = location.hash;

  const [devices, setDevices] = useState([]);
  const [device, setDevice] = useState({});
  const [simCards, setSimCards] = useState([]);
  const [simCard, setSimCard] = useState({});
  const [filterData, setFilterData] = useState({ param: '' });
  const [filterSimcardData, setFilterSimcardData] = useState({ param: '' });
  const [sortModel, setSortModel] = useState([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [valid, setValid] = useState(false);

  const validateForm = () => {
    if (device && simCard) { setValid(true); } else { setValid(false); }
  };

  async function getSimcardDeviceById() {
    setIsLoading(true);
    const result = await service.getSimCardDeviceById({ id: hash?.split('#')[1] });
    const data = result?.data || [];
    setDevice(data.deviceId);
    setSimCard(data.simcardId);
    setIsLoading(false);
  }

  async function getSimCards() {
    setIsLoading(true);
    const { field, sort } =
      sortModel.length > 0
        ? sortModel[0]
        : { field: 'createdAt', sort: 'desc' };
    const params = {
      ...filterSimcardData,
      size: 10,
      page: page,
      sort: `${field},${sort}`,
    };
    const result = await service.getSimcardsWithSearch(params);
    const data = result?.data || [];
    setSimCards(data.content);
    setIsLoading(false);
  }

  async function getDevices() {
    setIsLoading(true);
    const { field, sort } =
      sortModel.length > 0
        ? sortModel[0]
        : { field: 'createdAt', sort: 'desc' };
    const params = {
      ...filterData,
      size: 10,
      page: page,
      sort: `${field},${sort}`,
    };
    const result = await service.getDevicesWithSearch(params);
    const data = result?.data || [];
    setDevices(data.content);
    setIsLoading(false);
  }

  const handleUpdateMatchVehicle = async () => {
    await service
      .updateSimCardDevice({
        simcardDeviceId: hash?.split('#')[1], data: {
          deviceId: {
            id: device.id,
          },
          simcardId: {
            id: simCard.id,
          },
        }
      })
      .then((response) => {
        if (response?.status === 200 || response?.status === 201) {
          toast.success('SIM cihazla eşleştirildi.');
          navigate('/definitions/simcards');
          props.handleClose();
        } else {
          toast.error(
            "SIM cihazla eşleştirilirken bir hata oluştu. Cihazın eşleştiği SIM'i kontrol ediniz.",
          );
          props.handleClose();
        }
      });
  };

  const handleFilterInput = (newValue) => {
    setFilterData((prevFilterData) => ({
      ...prevFilterData,
      param: newValue,
    }));
  };

  const handleFilterSimcardInput = (newValue) => {
    setFilterSimcardData((prevFilterData) => ({
      ...prevFilterData,
      param: newValue,
    }));
  };

  useEffect(() => {
    getDevices();
  }, [filterData]);

  useEffect(() => {
    getSimCards();
  }, [filterSimcardData]);

  useEffect(() => {
    validateForm();
  }, [device, simCard]);

  useEffect(() => {
    getSimcardDeviceById();
  }, [hash]);

  return (
    <div>
      <Modal open={props.modalOpen} onClose={props.handleClose}>
        <Box style={boxStyle}>
          <Typography variant="h6" align="center" style={{ marginBottom: 20 }}>
            SIM - Cihaz <br /> Eşleşme Güncelleme
          </Typography>
          <div className="flex flex-wrap justify-evenly items-center">
            <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full p-2 m-2">
              <Autocomplete
                fullWidth
                options={devices}
                getOptionLabel={(option) => option?.imei}
                value={device}
                onChange={(e, value) => {
                  setDevice(value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cihazı Seçin"
                    variant="outlined"
                    size="small"
                    onChange={(e) => handleFilterInput(e.target.value)}
                    value={filterData.query}

                  />
                )}
              />
            </div>
            <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full p-2 m-2">
              <Autocomplete
                fullWidth
                options={simCards}
                getOptionLabel={(option) => option?.iccid}
                value={simCard}
                onChange={(e, value) => {
                  setSimCard(value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="SIM Seçin"
                    variant="outlined"
                    size="small"
                    onChange={(e) => handleFilterSimcardInput(e.target.value)}
                    value={filterSimcardData.query}

                  />
                )}
              />
            </div>
          </div>
          <div className="flex justify-center items-center p-2 m-2">
            <Button
              disabled={!valid || hash === ''}
              variant="outlined"
              color="primary"
              startIcon={<MATERIEL_ICONS.Link />}
              onClick={handleUpdateMatchVehicle}
              className="mx-2"
            >
              EŞLEŞTİR
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default EditMatchingModal;
